import { Icon } from '@acme/assets';
import React from 'react';

interface EsiaErrorsProps {
  className?: string;
}

export const EsiaErrors: React.FC<EsiaErrorsProps> = ({ className = '' }) => (
  <div
    className={`font-inter flex w-full flex-col items-center gap-2 pb-28 pt-20 text-center leading-[normal] ${className}`}
  >
    <Icon name="x-outline" size={44} />
    <div className="self-stretch pt-6 font-medium">
      Ошибка авторизации через ЕСИА
    </div>
    <div className="text-text-secondary flex items-center justify-center self-stretch">
      <p className="text-center">
        Проверьте, что вы используете подтверждённую учетную запись юридического
        лица
      </p>
    </div>
  </div>
);
